/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmTrxPendingStatusInfo } from '../models/EvmTrxPendingStatusInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmStatusWorkerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTrxPendingStatusInfo OK
     * @throws ApiError
     */
    public getEvmTransactionPendingStatus({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<EvmTrxPendingStatusInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/worker/transaction/pending/status',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmTrxPendingStatusInfo OK
     * @throws ApiError
     */
    public getEvmTransactionPendingStatus1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<EvmTrxPendingStatusInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/worker/transaction/pending/status',
            query: {
                'trxHash': trxHash,
            },
        });
    }

}
